'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { LinkSquare02Icon } from '@terra/ui-icons';
import { Text } from '../../../../../components/styled/text';
import type { OnOpenChatObject } from '../../hitl-types';
import type { ParsedWebPage } from '../../ToolCallsRenderers/types';

type WebPagesRendererProps = {
  webPages: ParsedWebPage[];
  onOpenObject?: OnOpenChatObject;
};

function WebPageItem({
  webPage,
  onOpenObject,
}: {
  webPage: ParsedWebPage;
  onOpenObject?: OnOpenChatObject;
}) {
  const displayText = webPage.url || 'Web page';
  const canOpenWebPage = Boolean(webPage.id && onOpenObject);
  const handleOpenWebPage = () => {
    if (!webPage.id || !onOpenObject) return;
    onOpenObject({
      type: 'webpage',
      id: webPage.id,
      label: displayText,
    });
  };

  return (
    <HStack
      gap={1.5}
      alignItems="center"
      cursor={canOpenWebPage ? 'pointer' : 'default'}
      _hover={canOpenWebPage ? { color: 'fg.default' } : undefined}
      onClick={canOpenWebPage ? handleOpenWebPage : undefined}
      width="100%"
      minWidth={0}
    >
      <LinkSquare02Icon size={10} style={{ flexShrink: 0 }} />
      <Text fontSize="xs" color="fg.muted" truncate flex={1}>
        {displayText}
      </Text>
    </HStack>
  );
}

export function WebPagesRenderer({
  webPages,
  onOpenObject,
}: WebPagesRendererProps) {
  return (
    <VStack gap={0.5} width="100%" overflowX="hidden" alignItems="stretch">
      {webPages.map((webPage, index) => (
        <WebPageItem
          key={webPage.id || `web-page-${index}`}
          webPage={webPage}
          onOpenObject={onOpenObject}
        />
      ))}
    </VStack>
  );
}
